module.exports = __webpack_public_path__ + "img/trade_tools.689b4e26.png";